export const IMMUTABLEX_DESCRIPTION = "Please sign this message to verify your ImmutableX account";